import { render, staticRenderFns } from "./EditClassesForm.vue?vue&type=template&id=4f57d1b4&"
import script from "./EditClassesForm.vue?vue&type=script&lang=js&"
export * from "./EditClassesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports